module.exports = __webpack_public_path__ + "static/media/kbank.2731610a.svg";